import { SearchContext } from '@giphy/react-components'
import { setGADataLayer } from 'analytics'
import { useRouter } from 'next/navigation'
import { useContext } from 'react'
import styled from 'styled-components'
import { CY_SEARCH_BAR__SUGGESTED_TERMS } from 'ui/src/utils/cy-test'
import { useSearchTags } from '../../../api/hooks'
import DropdownPingback from './dropdown-pingback'
import SearchIcon_ from './icons/search'
import { SearchSuggestionItem } from './search-suggestion-item'

const SearchIcon = styled(SearchIcon_)`
    @media (min-width: 1024px) {
        display: none;
    }
`

const Item = styled.div`
    display: flex;
    padding: 10px;
    font-style: italic;
    font-weight: 600;
    align-items: center;
    gap: 10px;
    cursor: pointer;
`

const SearchTags = () => {
    const { term } = useContext(SearchContext)
    const { data } = useSearchTags(term, { limit: 3 })
    const router = useRouter()
    return data?.data ? (
        <>
            {data.data.map(({ name, analytics_response_payload }) => (
                <DropdownPingback
                    key={name}
                    arp={analytics_response_payload}
                    responseId={data.meta.response_id}
                    eventType="DROPDOWN_AUTOCOMPLETE"
                    onClick={() => {
                        setGADataLayer({
                            event: 'search',
                            options: {
                                searchType: 'partial_search_suggestion',
                                searchTerm: name,
                            },
                        })
                        router.push(`/search/${encodeURIComponent(name)}`)
                    }}
                >
                    <Item className={CY_SEARCH_BAR__SUGGESTED_TERMS}>
                        <SearchIcon />
                        <SearchSuggestionItem term={term} item={name} />
                    </Item>
                </DropdownPingback>
            ))}
        </>
    ) : null
}
export default SearchTags
